import { event } from "@foretagsplatsen/yaem";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Empty renderable.
 */
export function emptyContent(_html) {}

/**
 * `DrawerMenuWidget` is a widget that slides from the right side of
 * the screen for big screens, showing an action menu about some point
 * of interest. It occupies the whole screen for the smaller screens.
 *
 * @param {Renderable} [content] - Renderable presenting some content.
 * @param {boolean} [visible] - Whether the drawer is visible by default.
 */
export default class DrawerMenuWidget extends Widget {
	constructor({ content = emptyContent, visible = false } = {}) {
		super(...arguments);

		this.onToggle = event();

		this._content = content;
		this._visible = visible;
	}

	setContent(content) {
		this._content = content;
		this.update();
	}

	show() {
		this._visible = true;
		this.asJQuery().find(".drawer-menu").addClass("active");
		this.onToggle.trigger({ visible: this._visible });
	}

	hide() {
		this._visible = false;
		this.asJQuery().find(".drawer-menu").removeClass("active");
		this.onToggle.trigger({ visible: this._visible });
	}

	isVisible() {
		return this._visible;
	}

	reset() {
		this._content = emptyContent;
		this.hide();
	}

	renderContentOn(html) {
		html.div(
			{
				klass: ["drawer-menu", { active: this._visible }],
				"data-test": "drawer-menu",
			},
			this.renderBodyOn.bind(this),
		);
	}

	renderBodyOn(html) {
		html.div({ klass: "content", "data-test": "content" }, this._content);
	}
}
